import { render, staticRenderFns } from "./PastEventDetails.vue?vue&type=template&id=f3ba961a&scoped=true&"
import script from "./PastEventDetails.vue?vue&type=script&lang=js&"
export * from "./PastEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./PastEventDetails.vue?vue&type=style&index=0&id=f3ba961a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ba961a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
